// helpers
import { serializeParameter, invokeMethodAsync, hasInvalidChars, scrollToElementBottom, scrollToElementTop } from './helpers';
import WindowHelper from './windowHelper';
import PopoverHelper from './popoverHelper';
// general
import ElementReference from './elementReference';
import InputAutoGrow from './inputAutoGrow';
import Ripple from './ripple';
import KeyInterceptorFactory from './keyInterceptor';
import SessionStorageHelper from './sessionStorageHelper';
import CookieStorageHelper from './cookieStorageHelper';
import LocalStorageHelper from './localStorageHelper';
import UserTagHelper from './userTagHelper';
import ResourceLoader from './resourceLoader';
import ScrollListener from './scrollListener';
import ScrollManager from './scrollManager';
import JsEventFactory from './jsEvent';
import DragAndDrop from './dragAndDrop';
import ThrottledEventManager from './throttledEventManager';
import ResizeObserverFactory from './resizeObserver';
import { ResizeListener, ResizeListenerFactory } from './resizeListener';
import Blob from './blob';
// components
import Alert from './alert';
import CodeSnippet from './codeSnippet';
import Toasts from './toasts';
import Tooltip from './tooltip';
import Theming from './theming';
import FeInput from './feInput';
import FileUpload from './file-upload';
import ScrollSpy from './scrollSpy';
import TimePicker from './timePicker';
import Popover from './popover';
import AppLayoutSidebar from './appLayoutSidebar';
import DocViewer from './docViewer';
import HtmlEditor from './htmlEditor';
import MarkdownEditor from './markdownEditor';

const FeBlazorLibrary = {
  // helpers
  serializeParameter,
  invokeMethodAsync,
  hasInvalidChars,
  scrollToElementBottom,
  scrollToElementTop,
  windowHelper: new WindowHelper(),
  popoverHelper: new PopoverHelper(),
  // general
  elementReference: new ElementReference(),
  inputAutoGrow: InputAutoGrow,
  ripple: new Ripple(),
  keyInterceptor: new KeyInterceptorFactory(),
  sessionStorage: SessionStorageHelper,
  localStorage: LocalStorageHelper,
  cookieStorage : CookieStorageHelper,
  userTag : UserTagHelper,
  resourceLoader: ResourceLoader,
  scrollListener: new ScrollListener(),
  scrollManager: new ScrollManager(),
  jsEvent: new JsEventFactory(),
  dragAndDrop: new DragAndDrop(),
  resizeObserver: new ResizeObserverFactory(),
  resizeListener: new ResizeListener(),
  resizeListenerFactory: new ResizeListenerFactory(),
  throttledEventManager: new ThrottledEventManager(),
  blob: new Blob(),
  // components
  alert: Alert,
  codeSnippet: CodeSnippet,
  toasts: Toasts,
  tooltip: Tooltip,
  theming: Theming,
  feInput: new FeInput(),
  fileUpload: new FileUpload(),
  scrollSpy: new ScrollSpy(),
  timePicker: new TimePicker(),
  popover: new Popover(),
  appLayoutSidebar: new AppLayoutSidebar(),
  docViewer: new DocViewer(),
  htmlEditor: new HtmlEditor(),
  markdownEditor: new MarkdownEditor()
};

export { FeBlazorLibrary };